class CartDiscountForm extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.input = this.querySelector('[name="discount"]');
    this.errorElement = this.querySelector('.cart-discount-form__error');
    this.applyButton = this.querySelector('[data-action="apply-discount"]');
    this.removeButton = this.querySelector('[data-action="remove-discount"]');

    this._onApply = this.onApply.bind(this);
    this._onRemove = this.onRemove.bind(this);
    this._onKeydown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onApply(event);
      }
    };

    this.applyButton?.addEventListener('click', this._onApply);
    this.removeButton?.addEventListener('click', this._onRemove);
    this.input?.addEventListener('keydown', this._onKeydown);
  }

  onApply(event) {
    event.preventDefault();
    const discountCode = this.input?.value.trim();
    if (!discountCode || !this.applyButton) return;

    this.updateDiscount(discountCode, {
      button: this.applyButton,
      validateApplied: true,
      expectedCode: discountCode,
    });
  }

  onRemove(event) {
    event.preventDefault();
    if (!this.removeButton) return;

    this.updateDiscount('', {
      button: this.removeButton,
      validateApplied: false,
    });
  }

  updateDiscount(discountCode, { button, validateApplied, expectedCode }) {
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    this.hideError();

    const sections = ['cart-drawer', 'cart-icon-bubble'];

    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        discount: discountCode,
        sections,
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          this.showError(parsedState.description || parsedState.message || window.cartStrings.error);
          return;
        }

        if (validateApplied) {
          const discountApplied =
            parsedState.total_discount > 0 ||
            (parsedState.discount_codes &&
              parsedState.discount_codes.some(
                (discount) => discount.applicable && discount.code.toLowerCase() === expectedCode.toLowerCase()
              ));

          if (!discountApplied) {
            this.showError(window.cartStrings.discountError);
            return;
          }
        }

        this.refreshCartSections(parsedState);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cartData: parsedState });
      })
      .catch(() => {
        this.showError(window.cartStrings.error);
      })
      .finally(() => {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      });
  }

  refreshCartSections(parsedState) {
    if (!parsedState.sections) return;

    const html = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
    ['cart-drawer-items', '.drawer__footer'].forEach((selector) => {
      const targetElement = document.querySelector(selector);
      const sourceElement = html.querySelector(selector);
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }
    });

    if (parsedState.sections['cart-icon-bubble']) {
      const cartIcon = document.getElementById('cart-icon-bubble');
      if (cartIcon) {
        cartIcon.innerHTML = new DOMParser()
          .parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html')
          .querySelector('.shopify-section').innerHTML;
      }
    }
  }

  showError(message) {
    if (!this.errorElement) return;
    this.errorElement.textContent = message;
    this.errorElement.classList.remove('hidden');
  }

  hideError() {
    if (!this.errorElement) return;
    this.errorElement.textContent = '';
    this.errorElement.classList.add('hidden');
  }
}

customElements.define('cart-discount-form', CartDiscountForm);
